/**
 * simplex controller
 */

import {factories} from '@strapi/strapi'
import {Context} from "koa";
import {
  TelegramLinkData,
  TelegramLinkInfo,
  TelegramLinkParams,
  TelegramLinkServiceType
} from "../../services/content-type/telegram-link";
import _ from "lodash";
import {validateLinkInfo} from "../../../src/services/utils/validate";

interface ValidateInitDataRequest {
  initData: string;
  bot?: string;
}
export default factories.createCoreController('plugin::telegram-bot.telegram-link', ({strapi}) => ({
  async validateInitData(ctx: Context) {
    const requestData = ctx.request.body as ValidateInitDataRequest;
    try {
      const validateRs = strapi
        .plugin('telegram-bot')
        .service<TelegramLinkServiceType>('telegram-link')
        .validateInitData(requestData.initData, requestData.bot);

      ctx.body = {
        success: true,
        data: validateRs
      }
    } catch (e) {
      ctx.body = {
        success: false,
        error: e.message
      }
    }
  },

  async getLinking(ctx: Context) {
    const params = ctx.query as Record<string, string>;

    // TODO: Issue-66: Filter params and sanitize

    const paramsValidate = {
      service: ctx.params.service,
      telegram_id: params.telegram_id ? parseInt(params.telegram_id, 10) : undefined,
      id: params.id ? parseInt(params.id, 10) : undefined,
      uid: params.uid,
      email: params.email,
      address: params.address,
    }

    validateLinkInfo(paramsValidate, true);

    ctx.body = await strapi
      .plugin('telegram-bot')
      .service<TelegramLinkServiceType>('telegram-link')
      .getLink({
        bot: ctx.params.bot,
        ...paramsValidate
      });
  },
  async setLinking(ctx: Context) {
    const request = ctx.request;
    const params = request.body as TelegramLinkParams<TelegramLinkData>;

    // TODO: Issue-66: Implement isAuthorized with data from ctx
    let isAuthorized=false;
    request.header.authorization ? isAuthorized=true : isAuthorized=false;

    const data = _.cloneDeep(params) as TelegramLinkParams<TelegramLinkInfo>;
    data.bot = ctx.params.bot;
    data.linkInfo.service = ctx.params.service;
    data.linkInfo.domain = request.headers['referer'] || request.headers['origin'];

    validateLinkInfo(data.linkInfo);

    ctx.body = await strapi
      .plugin('telegram-bot')
      .service<TelegramLinkServiceType>('telegram-link')
      .link(data, isAuthorized);
  },
}));
